import type { HelpFile } from '../../types/help'
import { LayoutActiveIndicatorTestIds } from '../../../testids/LayoutActiveIndicatorTestIds'

export const layoutActiveIndicatorHelp: HelpFile = {
  texts: {
    [LayoutActiveIndicatorTestIds.layoutActiveIndicator]:
      'Markiert das aktuell für diesen Entitätstyp aktive Formularlayout. Pro Typ wird zu jedem Zeitpunkt genau ein Layout an Endbenutzer ausgeliefert.',
  },
}
